import React, {useRef, useCallback, useState, useEffect} from 'react'; 
import { useDrag, useDrop } from 'react-dnd'; 
import { useSelector, useDispatch } from 'react-redux';
import { Progress, Divider, List } from 'antd';
import { CompletedIcon, NotCompletedFilledIcon, StarIcon, StarFilledIcon, DownloadIcon, ShareIcon } from '../academy.svg';
import { FormattedMessage, useIntl } from 'react-intl';
import { openNotificationWithIcon } from '../../../Utility/notificationMessage';
import { downloadCertificate, generateCertificate } from '../components/certificate';
import { format, isItemFinished, getNotFinishedTime, isAllLessonsFinished, saveNotFinishedLessons } from '../functions';
import { academyAPI } from '../../../../API/academy.api';
import { loginModalOpen } from '../../../../actions/Login/login.action';
import { academyConst } from '../academy';
import { DnDPointIcon } from '../../MainMenu/svg';
import update from 'immutability-helper';
import { decodeSpecLetters } from '../../../Utility/utility';

export const ItemTypes = {
    CARD: 'card',
};

export const Card = ({ id, index, moveCard, itemData, state, percent, cards,  handleDownload, handleShare, onClick, dragEnd }) => {
    const {finishedLessonsIds, finishedListIds, activeListKey, timeOfNotFinishedLessons, certificateIdByListId, edit, activeLessonKey} = state;
    let d = null;
    const ref = useRef(null);
    const dragRef = useRef(null);

    const [{ handlerId }, drop] = useDrop({
        accept: ItemTypes.CARD,
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            };
        },
        hover(item, monitor) {
            if (!ref.current) {
                return;
            }
            const dragIndex = item.index;
            const hoverIndex = index;
            if (dragIndex === hoverIndex) {
                return;
            }
            const hoverBoundingRect = ref.current?.getBoundingClientRect();
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            const clientOffset = monitor.getClientOffset();
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }
            moveCard(dragIndex, hoverIndex);
            item.index = hoverIndex;
        },
    });

    const [{ isDragging }, drag, previewLayer] = useDrag({
        type: ItemTypes.CARD,
        item: () => {
            return { id, index };
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end(item, monitor) {
            dragEnd(item);
        },
    });

    const opacity = isDragging ? 0 : 1;

    drag(dragRef);
    drop(ref);
    previewLayer(ref);


    if(index === cards.length-1){
        d = (
            <>
                <div 
                    className={activeLessonKey === "last" ? "lesson_item active" : "lesson_item"}
                    onClick={() => onClick(itemData, "last")}
                    key='last'
                >
                    <div className="item_checkbox">
                        {finishedListIds.includes(activeListKey) ? <StarFilledIcon width='19px' height='19px' /> : <StarIcon width='19px' height='19px' />}
                    </div>
                    <div className="item_content">
                        <div><FormattedMessage id="Training Course Certificate" defaultMessage="Training Course Certificate"/></div>
                        <div style={{fontSize: 10, letterSpacing: -0.4}}><FormattedMessage id="Add a Star to your profile showing you are a pro motorcycle tour planner" defaultMessage="Add a Star to your profile showing you are a pro motorcycle tour planner"/></div>
                    </div>
                    <div className="item_download" style={{marginLeft:0}}>
                        <DownloadIcon width="20px" height="20px" className="download_icon" onClick={(e) => handleDownload(e)}/>
                        <div className="download_div" onClick={(e) => handleDownload(e)}/>
                    </div>
                    <div className="item_share" style={{marginLeft:0}}>
                        <ShareIcon width="20px" height="20px" className="share_icon" onClick={(e) => handleShare(e, itemData, 'last')}/>
                        <div className="share_div" onClick={(e) => handleShare(e, itemData, 'last')}/>
                    </div>
                </div>
                <Divider orientation="left/right" className="divider_academy_item"/>
            </>
        )
    }

    return (
        <>
            <div 
                ref={ref} 
                style={{opacity}}
                data-handler-id={handlerId}   
                className={activeLessonKey === id ? "lesson_item active" : "lesson_item"}
                onClick={() => onClick(itemData)}
            >
                <div
                    className="dnd_icon_layout"
                    ref={dragRef}
                    style={{display: edit ? 'flex' : 'none'}}
                >
                    <DnDPointIcon width="18px" height="18px"/>
                </div> 
                <div className="item_checkbox" style={{width: edit ? 30 : 40}}>
                    {finishedLessonsIds.includes(itemData.id) ? <CompletedIcon width='16px' height='16px' /> : <NotCompletedFilledIcon width='16px' height='16px' />}
                </div>
                <div className="item_content">
                    <span>{decodeSpecLetters(itemData.title)}</span>
                    {itemData.video_duration && itemData.video_id ? (
                        <>
                            <span style={{fontSize: 10, fontWeight: 'bold'}}>{format(itemData.video_duration)}</span>
                            <Progress percent={finishedLessonsIds.includes(itemData.id) ? 100 : state.activeLessonKey === itemData.id ? percent : getNotFinishedTime(itemData, timeOfNotFinishedLessons)} showInfo={false} />
                        </>
                    ) : (
                        null
                    )}
                </div>
                <div className="item_share">
                    <ShareIcon width="20px" height="20px" className="share_icon"/>
                    <div className="share_div" onClick={(e) => handleShare(e, itemData)}/>
                </div>
            </div>
            <Divider orientation="left/right" className="divider_academy_item"/>  
            {d} 
        </>
    );
};

const Lesson = (props) => {
    const {lessons=[], setLessons, state, changeState, percent, setPercent, currentTime, lists} = props;
    const {finishedListIds, activeListKey, certificateIdByListId, timeOfNotFinishedLessons, activeLessonKey } = state;

    const [cards, setCards] = useState(lessons);

    useEffect(() => {
        setCards(lessons);
    }, [lessons]);

    const intl = useIntl();
    const dispatch = useDispatch();

    const {isLoggedIn, loginLoad, user} = useSelector(state => state.authentication);

    const onClick = (item, isLast=false, share=false) => {
        const shareData = share ? {shareModalShow: true, shareType: academyConst.LESSON} : {};
        if(isLast && !isAllLessonsFinished(lessons, state.finishedLessonsIds)){
            openNotificationWithIcon("warning",share ? intl.formatMessage({id: 'Finish the course to share your certificate', defaultMessage: 'Finish the course to share your certificate'}) : intl.formatMessage({id: 'Finished course to get your certificate', defaultMessage: 'Finished course to get your certificate'}))
            return;
        }else if(isLast && isAllLessonsFinished(lessons, state.finishedLessonsIds)){
            if(!loginLoad && !isLoggedIn){
                dispatch(loginModalOpen(true));
                return;
            }else{
                changeState({
                    activeLesson: {id: 'last'}, 
                    activeLessonKey: "last",
                    ...shareData
                }) 
                return;
            }
        } else {
            let notCompleteLessons = [];
            const activeNotFinishedItem = timeOfNotFinishedLessons.filter(x => x.id === item.id);

            if(percent < 100){
                notCompleteLessons = saveNotFinishedLessons(timeOfNotFinishedLessons, activeLessonKey, percent, currentTime);
            }

            changeState({
                activeLesson: item, 
                activeLessonKey: item.id, 
                timeOfNotFinishedLessons: [...notCompleteLessons],
                visibleDrawer: false,
                ...shareData
            });

            setPercent(activeNotFinishedItem[0] ? activeNotFinishedItem[0]['percent'] : 0);
        }
    }

    const handleDownload = (e) => {
        e.stopPropagation();
        if(!isItemFinished(activeListKey, finishedListIds)){
            openNotificationWithIcon("warning",intl.formatMessage({id: 'Finish the course to download your certificate', defaultMessage: 'Finish the course to download your certificate'}))
            return;
        }else{
            if(!loginLoad && !isLoggedIn){
                dispatch(loginModalOpen(true));
                return;
            }else{
                certificateIdByListId.map(item => {
                    if(item.list_id === state.activeListKey){
                        const list = lists.filter(i => i.id === state.activeListKey)[0];
                        const title = list.title.replace(/\s+/g, '_');
                        downloadCertificate(item.certificate_id, title);
                    }
                })
            }
        }
    }

    const handleShare = (e, item, isLast) => {
        e.stopPropagation();
        onClick(item, isLast, true);
    }

    const moveCard = useCallback((dragIndex, hoverIndex) => {
        const dragCard = cards[dragIndex];
        setCards(update(cards, {
            $splice: [
                [dragIndex, 1],
                [hoverIndex, 0, dragCard],
            ],
        }));
    }, [cards]);

    const dragEnd = () => {
        let data = [...cards];

        data.map((item,i) => {
            item.order_number = i + 1;
            academyAPI.save(item);
            return item;
        });

        setLessons(data);
    };

    const renderCard = (card, index) => {
        return (<Card 
            key={card.id} 
            index={index} 
            id={card.id} 
            moveCard={moveCard} 
            itemData={card} 
            state={state} 
            percent={percent}
            cards={cards}
            handleDownload={handleDownload}
            handleShare={handleShare}
            onClick={onClick}
            dragEnd={dragEnd}
        />);
    };
    return (
        <>
            <div className="lessons_list">{cards.map((card, i) => renderCard(card, i))}</div>
        </>
    );
}

export default Lesson;